import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Breadcrumbs } from '@/components/ui'
import type { IBreadcrumb } from '@/components/ui/Breadcrumbs/Breadcrumb/interfaces'
import { agroservicesBreadcrumb, homeBreadcrumb } from '@/components/ui/Breadcrumbs/constants'
import { injectMessages } from '@/logic/translation/utils'
import { FieldEvaluationReportDialogPublicLauncher } from '@/pages/Financing/components/FieldEvaluationReportDialogPublicLauncher'
import { EAgriculturalProductCategoryId } from '@/types/Catalog'
import { useDeviceType } from '@/utils/hooks/useDeviceType'
import { getCategoryUrl } from '@/utils/inputs/catalog/helpers'
import { AdvertisingBanner, AgroServices } from '../../components/resolvers'
import messages from './messages.json'
import './styles.scss'

injectMessages(messages)

const breadcrumbs: IBreadcrumb[] = [homeBreadcrumb, agroservicesBreadcrumb]

const Agroservices: React.FC = () => {
  const { isMobile } = useDeviceType()

  return (
    <div className="agroservices">
      <div className="page-wrapper">
        {!isMobile && (
          <div className="agroservices__topLine">
            <Breadcrumbs customBreadcrumbs={breadcrumbs} />
          </div>
        )}

        <h2 className="agroservices__heading">
          <FormattedMessage id="agroservices.page.title" />
        </h2>
      </div>

      <AgroServices />

      <AdvertisingBanner
        className="agroservices__banner"
        buttonTextId="agroservices.bottomBanner.link"
        titleId="agroservices.bottomBanner.title"
        backgroundImage="agroservices/fertilizers"
        descriptionId="agroservices.bottomBanner.description"
        linkUrl={getCategoryUrl(EAgriculturalProductCategoryId.fertilizers)}
        textClass="agroservices__bannerText"
        titleSize={2}
        isSqueezed
        isButtonSmall
      />

      <FieldEvaluationReportDialogPublicLauncher comment={messages.ru['fieldEvaluationReportDialog.comment']} />
    </div>
  )
}

export default Agroservices
